import { render, staticRenderFns } from "./checklist-step.vue?vue&type=template&id=639da01b&"
import script from "./checklist-step.vue?vue&type=script&lang=js&"
export * from "./checklist-step.vue?vue&type=script&lang=js&"
import style0 from "./checklist-step.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports